import { createFileRoute } from '@tanstack/react-router';
import { OrganizationSubscriptions } from '@uturn/portal/modules/org/pages/subscriptions';

export const Route = createFileRoute(
	'/_protected/org/$orgId/settings/subscriptions',
)({
	component: OrganizationSubscriptions,
});
